import html2canvas from "html2canvas";

const useScreenshot = () => {
  const screenshotTarget: HTMLElement = document.getElementById("content-reader") ?? document.body;

  const takeScreenshot = async (): Promise<string> =>
    html2canvas(screenshotTarget, { useCORS: true }).then((canvas: HTMLCanvasElement) => {
      const base64image: string = canvas.toDataURL("image/png");
      return base64image;
    });

  const downloadScreenshot = async (fileName: string) => {
    const base64image = await takeScreenshot();
    const a = document.createElement("a");
    a.href = base64image;
    a.download = fileName;
    a.click();
  };

  return { takeScreenshot, downloadScreenshot };
};

export default useScreenshot;
